import axios from '../../plugins/axios';

/**
 *
 * @param {Object} data - ÐÐ°Ð½Ð½ÑÐµ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°
 * @param {number} data.id - ID Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ° (0 Ð´Ð»Ñ Ð½Ð¾Ð²Ð¾Ð³Ð¾)
 * @param {string} data.FirstName - ÐÐ¼Ñ
 * @param {string} data.LastName - Ð¤Ð°Ð¼Ð¸Ð»Ð¸Ñ
 * @param {string} data.MiddleName - ÐÑÑÐµÑÑÐ²Ð¾
 * @param {string} data.IIN - ÐÐÐ
 * @param {string} data.DOCUMENT_GIVED_DATE - ÐÐ°ÑÐ° Ð²ÑÐ´Ð°ÑÐ¸ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°
 * @param {string} data.DOCUMENT_NUMBER - ÐÐ¾Ð¼ÐµÑ ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ñ
 * @param {string} data.ADDRESS - ÐÐ´ÑÐµÑ
 * @param {string} data.CONTACT_PHONE - Ð¢ÐµÐ»ÐµÑÐ¾Ð½
 * @param {number} data.CarId - ID Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ
 * @param {string} data.bankAccount - ÐÐ°Ð½ÐºÐ¾Ð²ÑÐºÐ¸Ð¹ ÑÑÐµÑ
 * @param {string} data.bankName - ÐÐ°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ðµ Ð±Ð°Ð½ÐºÐ°
 * @param {string} data.bankBic - ÐÐÐ
 * @returns {Promise<Object>}
 */
export async function createSeller(data) {
  const formData = new FormData();
  formData.append('json', JSON.stringify(data));

  const response = await axios.post(
    '/api/crm/cars/createSeller', formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      withCredentials: true,
    }
  );
  return response.data;
} 